import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const VerticalCenterDiv = styled.div({
  [media('lg')]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

export default VerticalCenterDiv;
